import { USER_ROLES } from "@constants/user.roles";

/** Persisted sidebar state for standard admin users (default expanded). */
export const SIDEBAR_COLLAPSED_KEY = "sidebar_collapsed";
/** Persisted sidebar state for CM dashboard only (default collapsed). */
export const SIDEBAR_COLLAPSED_CM_KEY = "sidebar_collapsed_cm";

export type CmDashboardSessionUser = {
	isCmDashboard?: boolean;
	roles?: string[];
};

export function isCmAdminUser(user: CmDashboardSessionUser | null | undefined): boolean {
	if (!user) return false;
	if (user.isCmDashboard === true) return true;
	return user.roles?.includes(USER_ROLES.CHIEF_MINISTER) ?? false;
}

export function getSidebarCollapsedStorageKey(user: CmDashboardSessionUser | null | undefined): string {
	return isCmAdminUser(user) ? SIDEBAR_COLLAPSED_CM_KEY : SIDEBAR_COLLAPSED_KEY;
}

/** CM: collapsed by default. Other admins: expanded by default (uses separate storage). */
export function getInitialSidebarCollapsed(user: CmDashboardSessionUser | null | undefined): boolean {
	const storageKey = getSidebarCollapsedStorageKey(user);
	const defaultCollapsed = isCmAdminUser(user);

	try {
		const stored = localStorage.getItem(storageKey);
		if (stored === null) return defaultCollapsed;
		return JSON.parse(stored) as boolean;
	} catch {
		return defaultCollapsed;
	}
}

/** CM dashboard opens with the sidebar collapsed. */
export function collapseSidebarForCm(): void {
	localStorage.setItem(SIDEBAR_COLLAPSED_CM_KEY, "true");
	window.dispatchEvent(new CustomEvent("sidebarToggle", { detail: { isCollapsed: true } }));
}

/** Standard admin login: expanded sidebar (does not affect CM preference). */
export function expandSidebarForAdmin(): void {
	localStorage.setItem(SIDEBAR_COLLAPSED_KEY, "false");
	window.dispatchEvent(new CustomEvent("sidebarToggle", { detail: { isCollapsed: false } }));
}
